import FeatureGate from "@/src/components/feature-gate";
import WikiCreationScreen from "@/src/screens/wiki/wiki-creation-screen/wiki-creation-screen";

export default function WikiCreation() {
  return (
    <FeatureGate feature="wiki">
      <WikiCreationScreen />
    </FeatureGate>
  );
}
